module.exports = __webpack_public_path__ + "img/wired-connected.dab42999.svg";